import { siteConfig } from "@/config/site";

export type ApiErrorBody = {
  error?: { code?: string; message?: string; details?: unknown };
} | null;

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: ApiErrorBody,
  ) {
    super(body?.error?.message ?? `Request failed with status ${status}`);
    this.name = "ApiError";
  }

  get code() {
    return this.body?.error?.code;
  }
}

let onUnauthorized: (() => void) | undefined;

export function setUnauthorizedHandler(handler?: () => void) {
  onUnauthorized = handler;
}

export async function apiRequest<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(`${siteConfig.apiBaseUrl}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as ApiErrorBody;

    if (response.status === 401) onUnauthorized?.();
    throw new ApiError(response.status, body);
  }

  return response.status === 204
    ? (undefined as T)
    : (response.json() as Promise<T>);
}
